import * as React from 'react';
import ReactTooltip from 'react-tooltip';
import * as classnames from 'classnames';
import { QuestionID } from '@nexxt/common/types';

interface QuestionAddButtonProps {
    questionID: QuestionID;
    bottom?: boolean;
    show?: boolean;
    customInlineStyle?: any;
    onMouseEvent?: (e, enable: boolean) => void;
    addQuestion: (e) => void;
}

const QuestionAddButton: React.FC<QuestionAddButtonProps> = (
    props: QuestionAddButtonProps
) => {
    const {
        addQuestion,
        onMouseEvent,
        questionID,
        bottom,
        show,
        customInlineStyle
    } = props;
    return (
        <div
            className={classnames('question--add-button-container', {
                bottom
            })}
            style={customInlineStyle}
            onClick={(e) => e.stopPropagation()}
            onMouseLeave={(e) => onMouseEvent(e, false)}
            onMouseOver={(e) => onMouseEvent(e, true)}
        >
            {show && (
                <>
                    <span
                        className="question--add-button"
                        data-tip="custom show"
                        data-for={`add-question-${questionID}`}
                        onClick={(e) => addQuestion(e)}
                    >
                        +
                    </span>
                    <ReactTooltip
                        id={`add-question-${questionID}`}
                        aria-haspopup="true"
                        effect="solid"
                        place="right"
                        className="question--add-button-tooltip"
                    >
                        <span>INSERT NEW QUESTION</span>
                    </ReactTooltip>
                    {/* hide this design for now <hr /> */}
                </>
            )}
        </div>
    );
};

export default QuestionAddButton;
